/**
 * Small formatting helpers shared between `ChannelSchedulePreview` and
 * `EpgEventDetailDialog` - split out so the detail dialog does not have to
 * import from the panel (a schedule row opening a dialog that imports back
 * from the panel that renders it is a circular import waiting to bite the
 * next change to either file).
 */

export function clock(iso: string): string {
  const ms = Date.parse(iso);
  if (Number.isNaN(ms)) return "??:??";
  return new Date(ms).toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function day(iso: string): string {
  const ms = Date.parse(iso);
  if (Number.isNaN(ms)) return "—";
  return new Date(ms).toLocaleDateString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
}

/** Both instants, stated - never "today", which this data cannot promise. */
export function stamp(iso: string): string {
  return `${day(iso)} ${clock(iso)}`;
}

export function span(seconds: number): string {
  if (seconds < 60) return `${Math.max(0, Math.round(seconds))} s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours} h ${rest} min` : `${hours} h`;
}
